export async function copyToClipboard(value: string | undefined): Promise<boolean> {
  if (!value) {
    return false;
  }

  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch (error) {
    console.warn('Could not write to the clipboard', error);
    return false;
  }
}
